/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { GuestSpace } from "./GuestSpace";
export const GuestConfig = core.serialization.object({
    environmentId: EnvironmentId,
    email: core.serialization.string(),
    name: core.serialization.string(),
    spaces: core.serialization.list(GuestSpace),
});
